import { Helpers } from "../Helpers";
import { IDIService } from "../IDIService";

interface IAndroidAppRate {
    OpenRateDialogAsync(): Promise<void>;
}

export interface IAppRateService extends IDIService {
    OpenRateDialogAsync(): Promise<void>;
    IsAvailable(): boolean;
}

export class AppRateService implements IAppRateService {
    public static readonly ServiceName: string = "AppRateService";

    OpenRateDialogAsync(): Promise<void> {
        if (Helpers.IsIosNative()) {
            try {
                if ((window as any).webkit.messageHandlers.rateApp != undefined) {
                    (window as any).webkit.messageHandlers.rateApp.postMessage(true);
                    return Promise.resolve();
                }
            }
            catch (err) {
                return Promise.reject(new Error(`Rate dialog is not available on this platform. Error: ${err}`));
            }
        }
        else if (this.IsAvailable()) {
            return (navigator as any).AndroidAppRate.OpenRateDialogAsync();
        }

        return Promise.reject(new Error("AppRateService is not available on this platform."));
    }

    IsAvailable(): boolean {
        return (navigator as any).AndroidAppRate !== undefined || (window as any).webkit?.messageHandlers?.rateApp !== undefined;
    }

    GetServiceName(): string {
        return AppRateService.ServiceName;
    }

}